/** @jsxImportSource @emotion/react */
import React, { Fragment, useMemo, useState } from "react";
import { Column, useGlobalFilter, useSortBy, useTable } from "react-table";
import { useNavigate } from "react-router-dom";

import { Text } from "../../atoms";
import * as styles from "./index.styles";
import { Modal } from "../../../components/templates";
import { toast } from "react-toastify";

export type Props = {
  columns: Column<any>[];
  data: any[];
  route?: string;
};

const TableBase: React.FC<Props> = ({
  columns: columnsTable,
  data: dataTable,
  route,
}) => {
  const navigate = useNavigate();

  const columns = useMemo((): Column<any>[] => columnsTable, [columnsTable]);
  const data = useMemo((): any[] => dataTable, [dataTable]);

  const tabla = useTable({ columns, data }, useGlobalFilter, useSortBy);

  const [show, setShow] = useState(false);
  const [idData, setIdData] = useState({ id: 0, type: "" });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = tabla;

  const handleDirect = (row: any) => {
    navigate(`${route}${row.original.id}`);
  };

  const actionDelete = (data: any) => {
    console.log(data.id);

    toast.success("Eliminación exitosa!", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

    setShow(false);
  };

  return (
    <Fragment>
      <Modal
        show={show}
        text=""
        title="¿Está seguro que desea eliminar?"
        btnSuccess="Cancelar"
        btnWarning="Eliminar"
        onClickWarning={() => {
          actionDelete(idData);
        }}
        onClickSuccess={() => {
          setShow(false);
        }}
        onClickClose={() => {
          setShow(false);
        }}
      />

      <div css={styles.tableWrapper}>
        <table {...getTableProps()} css={styles.table}>
          <thead css={styles.tableHeader}>
            {headerGroups.map((headerGroup, index) => (
              <tr
                {...headerGroup.getHeaderGroupProps()}
                css={styles.tableHeaderRow}
                key={`tr-${index}`}
              >
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    css={styles.tableHeaderCell}
                    key={`th-${column.render("Header")}`}
                  >
                    {column.render("Header")}
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <span> ↓</span>
                      ) : (
                        <span> ↑</span>
                      )
                    ) : (
                      ""
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()} css={styles.tableBody}>
            {rows.map((row) => {
              prepareRow(row);

              return (
                <tr {...row.getRowProps()} css={styles.tableBodyRow}>
                  {row.cells.map((cell) => {
                    if (cell.column.id === "isActive") {
                      const isActive = Boolean(cell.value);

                      return (
                        <td {...cell.getCellProps()} css={styles.tableBodyCell}>
                          <span css={styles.statusBadge(isActive)}>
                            {isActive ? "Activo" : "Inactivo"}
                          </span>
                        </td>
                      );
                    }

                    if (cell.column.id === "actions") {
                      return (
                        <td {...cell.getCellProps()} css={styles.tableBodyCell}>
                          <button
                            css={styles.actionButton}
                            onClick={() => handleDirect(row)}
                          >
                            Editar
                          </button>
                        </td>
                      );
                    }

                    return (
                      <td {...cell.getCellProps()} css={styles.tableBodyCell}>
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>

        {rows.length === 0 && (
          <div css={styles.emptyState}>
            <Text textType="sm">No hay datos en la tabla.</Text>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default TableBase;